import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography} from "@mui/material";
import React from "react";
import {LoadingButton} from "../../../../../../../../newShared/components/Basic/CommonButtons";
import {useMainTranslation} from "../../../../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {useDeleteWorkspaceDialog} from "../../../../../hooks/organizations/dialogs/useDeleteWorkspaceDialog";

export const DeleteWorkspaceDialogs = () => {
    const {t, revDir} = useMainTranslation('', {keyPrefix: 'pathSettings.dialogs'});
    const {
        isOpen,
        isLoading,
        handleClose,
        handleSubmit,
        selected
    } = useDeleteWorkspaceDialog();
    return(
        <Dialog open={isOpen} onClose={handleClose}>
            <DialogTitle>{t('Delete workspace')}</DialogTitle>

            <DialogContent>
                <DialogContentText>
                    <Typography variant={'body2'}>{t('Workspace {{name}} will be deleted. All users and all workspace data will be deleted.', {name: selected?.name ?? ''})}</Typography>
                    <Typography variant={'body2'} sx={{margin: '8px 0 0 0'}}>{t('Are you sure you want to delete this workspace?')}</Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose} disabled={isLoading} variant={'text'}>{t('Cancel')}</Button>
                <LoadingButton
                    sx={{margin: !revDir ? '0 16px 0 0' : '0 0 0 16px'}}
                    loading={isLoading}
                    onClick={handleSubmit}
                >
                    {t('Delete')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}